import validator from 'email-validator';
import React, { Component } from 'react';
import { NewSubpatientFormView } from './NewSubpatientFormView';

/**
 * @param {string} emailErrorMessage
 * @param {string} nameErrorMessage
 * @param {function(mainPatientId: string, subpatient: Object): void} onContinue
 * @param {function(
 *     subPatientPatientId: string,
 *     subPatientFirstName: string,
 *     subPatientLastNam: string
 * ): void} onSubpatientCreated
 * @param {boolean} showDateError
 * @param {function(): void} trackFemaleGenderFieldSelect
 * @param {function(): void} trackIsLegalGuardianFieldSelect
 * @param {function(): void} trackIsNotLegalGuardianFieldSelect
 * @param {function(): void} trackMaleGenderFieldSelect
 * @param {function(): void} trackNewSubpatientClickContinue
 * @param {function(): void} trackNewSubPatientDayDOBFieldSelect
 * @param {function(): void} trackNewSubPatientEmailFieldSelect
 * @param {function(): void} trackNewSubPatientFirstNameFieldSelect
 * @param {function(): void} trackNewSubPatientLastNameFieldSelect
 * @param {function(): void} trackNewSubPatientMonthDOBFieldSelect
 * @param {function(): void} trackNewSubPatientYearDOBFieldSelect
 * @returns {JSX.Element}
 * @constructor
 */
export class NewSubpatientFormContainer extends Component {
    state = {};

    componentWillReceiveProps(nextProps) {
        if (nextProps.subpatientCreationFailure) {
            this.updateErrorState(nextProps);
        }
        if (
            nextProps.subpatientCreationSuccess &&
            !this.props.subpatientCreationSuccess
        ) {
            this.updateErrorState(nextProps);
            this.props.onSubpatientCreated(
                nextProps.subPatientPatientId,
                nextProps.subPatientFirstName,
                nextProps.subPatientLastName
            );
        }
    }

    updateErrorState = (nextProps) => {
        this.setState({
            showDateError: nextProps.showDateError,
            emailErrorMessage: nextProps.emailErrorMessage,
            showNameError: !!nextProps.nameErrorMessage,
        });
    };

    handleSexChange = (sex) => {
        this.setState({
            sex,
            showSexError: false,
        });

        if (sex === 'female') {
            this.props.trackFemaleGenderFieldSelect();
        } else if (sex === 'male') {
            this.props.trackMaleGenderFieldSelect();
        }
    };

    handleLegalGuardianChange = (isLegalGuardian) => {
        this.setState({
            isLegalGuardian,
            showLegalGuardianError: false,
        });

        if (isLegalGuardian === 'yes') {
            this.props.trackIsLegalGuardianFieldSelect();
        } else if (isLegalGuardian === 'no') {
            this.props.trackIsNotLegalGuardianFieldSelect();
        }
    };

    validateEmail = (email) => {
        if (!email) {
            this.setState({
                emailErrorMessage: undefined,
                emailFormatError: undefined,
                email,
            });
            return;
        }

        if (validator.validate(email)) {
            this.setState({
                emailErrorMessage: undefined,
                emailFormatError: undefined,
                email,
            });
        } else {
            this.setState({
                emailErrorMessage: undefined,
                emailFormatError: true,
            });
        }
    };

    fieldIsFilledOut = (field) => {
        return !!field && field.length !== 0;
    };

    emailIsValid = () => {
        return !this.state.emailFormatError;
    };

    validateForm = () => {
        const { firstName, lastName, birthDate, sex, isLegalGuardian } =
            this.state;

        const isValid =
            this.fieldIsFilledOut(firstName) &&
            this.fieldIsFilledOut(lastName) &&
            this.fieldIsFilledOut(birthDate) &&
            this.fieldIsFilledOut(sex) &&
            this.fieldIsFilledOut(isLegalGuardian) &&
            this.emailIsValid();

        if (isValid) {
            return isValid;
        }

        const showNameError = !(
            this.fieldIsFilledOut(firstName) && this.fieldIsFilledOut(lastName)
        );
        const showDateError = !this.fieldIsFilledOut(birthDate);
        const showSexError = !this.fieldIsFilledOut(sex);
        const showLegalGuardianError = !this.fieldIsFilledOut(isLegalGuardian);

        this.setState({
            showNameError,
            showDateError,
            showSexError,
            showLegalGuardianError,
        });
    };

    handleClickContinue = () => {
        this.props.trackNewSubpatientClickContinue();

        const { firstName, lastName, email, birthDate, sex, isLegalGuardian } =
            this.state;

        if (this.validateForm()) {
            this.props.onContinue(this.props.patientId, {
                firstName,
                lastName,
                email,
                birthDate,
                sex,
                isLegalGuardian,
            });
        }
    };

    handleBirthDateChange = (birthDateInput) => {
        this.setState({
            birthDate: birthDateInput,
            showDateError: undefined,
        });
    };

    handleFirstNameChange = (firstNameInput) => {
        this.setState({
            firstName: firstNameInput,
            showNameError: false,
        });
    };

    handleLastNameChange = (lastNameInput) => {
        this.setState({
            lastName: lastNameInput,
            showNameError: false,
        });
    };

    render() {
        const {
            emailFormatError,
            emailErrorMessage,
            showNameError,
            showDateError,
            showSexError,
            showLegalGuardianError,
        } = this.state;

        return (
            <NewSubpatientFormView
                emailFormatError={emailFormatError}
                invalidEmailMessage={emailErrorMessage}
                onBirthDateChange={this.handleBirthDateChange}
                onClickContinue={this.handleClickContinue}
                onDayFocus={this.props.trackNewSubPatientDayDOBFieldSelect}
                onEmailChange={this.validateEmail}
                onEmailFocus={this.props.trackNewSubPatientEmailFieldSelect}
                onFirstNameChange={this.handleFirstNameChange}
                onFirstNameFocus={
                    this.props.trackNewSubPatientFirstNameFieldSelect
                }
                onLastNameChange={this.handleLastNameChange}
                onLastNameFocus={
                    this.props.trackNewSubPatientLastNameFieldSelect
                }
                onLegalGuardianChange={this.handleLegalGuardianChange}
                onMonthFocus={this.props.trackNewSubPatientMonthDOBFieldSelect}
                onSexChange={this.handleSexChange}
                onYearFocus={this.props.trackNewSubPatientYearDOBFieldSelect}
                showDateError={showDateError}
                showLegalGuardianError={showLegalGuardianError}
                showNameError={showNameError}
                showSexError={showSexError}
            />
        );
    }
}
